import { render, staticRenderFns } from "./JobRiskEdit.vue?vue&type=template&id=483481f4&"
import script from "./JobRiskEdit.vue?vue&type=script&lang=js&"
export * from "./JobRiskEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports